import { render, staticRenderFns } from "./classificationTags.vue?vue&type=template&id=21b894a3"
import script from "./classificationTags.vue?vue&type=script&lang=js"
export * from "./classificationTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports